import DataObject from "@mui/icons-material/DataObject";
import { type SxProps, type Theme, ToggleButton, Tooltip } from "@mui/material";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { usePopover } from "../../../utils/hooks/use-popover";
import { MergeTagLookup } from "./merge-tag-lookup";
import type { TagGroup } from "./types";

type Props = {
  disabled?: boolean;
  onSelection: (tagId: string) => void;
  filterTags: (x: string) => TagGroup;
  buttonStyle?: SxProps<Theme>;
  editor: "draftjs" | "lexical";
};

export const TokenPickerV2: FC<Props> = ({
  disabled,
  onSelection,
  filterTags,
  buttonStyle,
  editor,
}) => {
  const { t } = useTranslation();
  const popover = usePopover<HTMLButtonElement>();

  const handleSelection = useCallback(
    (tagId: string): void => {
      if (!tagId) return;

      onSelection(`{{${tagId}}}`);
      popover.handleClose();
    },
    [onSelection, popover],
  );

  return (
    <>
      <Tooltip title={t("Merge tags")}>
        <span>
          <ToggleButton
            data-analytics-id={`${editor}-toolbar-merge-tag-picker`}
            data-testid="add-token"
            onMouseDown={(e) => e.preventDefault()}
            onClick={popover.handleToggle}
            value="token"
            sx={buttonStyle || { border: "none", borderRadius: 0 }}
            disabled={disabled}
            ref={popover.anchorRef}
          >
            <DataObject fontSize="small" />
          </ToggleButton>
        </span>
      </Tooltip>
      <MergeTagLookup
        // eslint-disable-next-line react-hooks/refs
        open={popover.open}
        // eslint-disable-next-line react-hooks/refs
        anchorEl={popover.anchorRef?.current}
        // eslint-disable-next-line react-hooks/refs
        onClose={popover.handleClose}
        filterTags={filterTags}
        onSelection={handleSelection}
      />
    </>
  );
};
